import "../LandingPageStyle.scss";
import "./MoelkPageStyle.scss";
import { IJSLComponent, IJSLVNode } from "jsl-render";
import { EPCSOLandingForm } from "../../../ajax/types/EPCSOLandingForm";
import { StartersetComponent } from "../StartersetComponent";
import { mapUrl } from "../../../helper/mapUrl";
import { StackPanelComponent } from "jsl-ui";

export class MoelkPageComponent implements IJSLComponent {

    private actualForm: IJSLComponent;

    public constructor(private options: EPCSOLandingForm) {
        this.actualForm = new StartersetComponent(options, new Date(2025, 7 /* TODO: change to 8 later on - not 9 - we are in javascript */, 1));
    }

    public render(): IJSLVNode {
        return <div class="moelk-page-comp" style="padding-top:5rem;padding-bottom: 1px;">
            {/* <div class="nav-header">
                <div style="float:right;padding:1rem;padding-right:5vw;max-width: 50vw;">
                    <button class="jsl-button" style="width:12rem;" click={() => {
                        const el = document.getElementById("anchor-register");
                        if (el != null) {
                            el.scrollIntoView({
                                behavior: "smooth",
                                block: "start"
                            });
                        }
                    }}>REGISTRIERUNG</button>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button class="jsl-button" style="width:12rem;background-color:#FF2D30;"
                        click={() => {
                            const el = document.getElementById("anchor-rezepte");
                            if (el != null) {
                                el.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start"
                                });
                            }
                        }}>Rezepte</button>
                </div>
                <img src={mapUrl("Content/images/logo.png")} style="height:3.1rem" />
                <div style="clear:both"></div>
            </div> */}

            <div class="sommer-cover">
                {new StackPanelComponent([
                    <div>
                        <h1>Mehr. Ganz einfach.</h1>

<p><strong>Mehr Vielfalt. Mehr Genuss. Mehr Kaffeemomente.</strong></p>
                       
                        <p>Sie haben sich für eine NIVO 9000er entschieden? Dann gibt es jetzt noch mehr dazu: Registrieren Sie Ihr neues Gerät nach dem Kauf einfach hier und sichern Sie sich unser exklusives <strong>Genuss-Set im Wert von über 50 Euro.</strong></p>
                        
                    </div>,
                    <div style="margin-left:2rem;">
                        <img src={mapUrl("Content/images/sommer/nivona_transparency.png")}
                            alt="Nivona x eismann" style="width:80vw;max-width:36rem;margin-top:-2.8rem;" />
                    </div>
                ], { orientation: "horizontal", responsive: true })}


                        <p>Freuen Sie sich auf:

                            <ul>
                                <li><strong>eine NIVONA Milchlanze </strong> – für Milch oder Hafermilch direkt aus der Verpackung</li>
                            <li><strong>8 Liter Mølk Hafer Barista </strong> – für cremigen Cappuccino und Co.</li>
                            <li><strong>eine Chilled Brew-Box </strong> – für einen besonderen kalten Kaffeemoment</li>
                            </ul>
                        </p>

                        <p>Füllen Sie einfach das Formular auf dieser Seite aus und senden Sie Ihre Daten ab. Wir kümmern uns um den Rest.</p>
                        
                        <div><button class="jsl-button" style="width:16rem;" click={() => {
                            const el = document.getElementById("anchor-register");
                            if (el != null) {
                                el.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start"
                                });
                            }
                        }}>JETZT REGISTRIEREN</button></div>
                        <p>&nbsp;</p>

                <p>
                   <strong>Heiß oder kalt. Mit Milch oder Hafer. Hauptsache einfach gut.</strong>
                </p>
                <p>
                Mit Ihrer NIVO 9000er können Sie Kaffeegenuss ganz nach Ihrem Geschmack genießen. Die Milchlanze macht den Wechsel zwischen Milch und Pflanzendrink besonders unkompliziert. Und mit der Chilled Brew-Box können Sie direkt eine ganz andere Seite Ihrer NIVONA ausprobieren.
                </p>
                <p>Die <strong>Chilled Brew-Box</strong> enthält zwei NIVONA-Kaffeegläser, Kaffee, ein Rezeptheft sowie eine Flasche <strong>Aqua Monaco Tonic Water (0,33 l)</strong> – perfekt für einen erfrischenden Chilled Brew Tonic.

                </p>
                <p><strong>Nur solange der Vorrat reicht.</strong></p>
            <p>
                <i>Die Aktion gilt beim Kauf eines Modells der NIVO 9000er-Serie im Aktionszeitraum bis 31. Januar 2027 bei einem autorisierten NIVONA-Fachhändler in Deutschland und anschließender Online-Registrierung. Teilnahmeberechtigt sind Endkunden ab 18 Jahren mit Wohnsitz in Deutschland. Die Zugabe ist nur erhältlich, solange der Vorrat reicht.</i>
            </p>
            </div>



            <div style="background:#F0EAE7;">
                <div id="anchor-register" class="landing-page-comp" style="background:none;max-width:1200px;margin:auto;">
                    <div class="register-header">
                        <h1>Registrierung</h1>
                    </div>
                    {this.actualForm}
                </div>
            </div>
            {/* 
            <div id="anchor-rezepte">
                <div style="background:#DA0021;color:white;padding:1.6rem;text-align:center">
                    <h1 style="font-size: 2.8rem;">Kaffeebohne küsst Sonne</h1>
                    <p style="max-width:825px;font-size:1.1rem;line-height:1.6rem;margin:auto;">Gutschein im Wert von 2x 30 Euro für Eismann und 1x CoffeeBag mit je 250 Gramm der NIVONA-Kaffeesorten.
                        <br />
                        Eben alles, was Du für Deine perfekte Auszeit mit Eiskaffee brauchst. Nur Dein Plätzchen in der Sonne musst Du jetzt noch selbst finden.</p>
                </div>
                <div style="max-width:1200px;text-align:center;margin:auto;">
                    <h1 style="font-size:5rem">Rezepte</h1>
                    {new StackPanelComponent([

                        <div style="margin-bottom:1rem;">
                            <div><img src={mapUrl("Content/images/sommer/Coffee1.png")} alt="Tropical Espresso" style="max-width:14rem" /></div>
                            <div><button class="jsl-button"
                                style="background: #c6ad9f; color: white; padding:1rem;height: 3rem;line-height: 1.3rem;width:60%" click={() => {
                                    const el = document.getElementById("rezepte-1");
                                    if (el != null) {
                                        el.scrollIntoView({
                                            behavior: "smooth",
                                            block: "start"
                                        });
                                    }
                                }}>TROPICAL ESPRESSO</button></div>
                        </div>,

                        <div style="margin-bottom:1rem;">
                            <div><img src={mapUrl("Content/images/sommer/Coffee2.png")} alt="CAPPUCCINO ICE" style="max-width:14rem" /></div>
                            <div><button class="jsl-button"
                                style="background: #c6ad9f; color: white; padding:1rem;height: 3rem;line-height: 1.3rem;width:60%" click={() => {
                                    const el = document.getElementById("rezepte-2");
                                    if (el != null) {
                                        el.scrollIntoView({
                                            behavior: "smooth",
                                            block: "start"
                                        });
                                    }
                                }}>CAPPUCCINO ICE</button></div>
                        </div>,

                        <div style="margin-bottom:1rem;">
                            <div><img src={mapUrl("Content/images/sommer/Coffee3.png")} alt="ESPRESSO WILD" style="max-width:14rem" /></div>
                            <div><button class="jsl-button"
                                style="background: #c6ad9f; color: white; padding:1rem;height: 3rem;line-height: 1.3rem;width:60%" click={() => {
                                    const el = document.getElementById("rezepte-3");
                                    if (el != null) {
                                        el.scrollIntoView({
                                            behavior: "smooth",
                                            block: "start"
                                        });
                                    }
                                }}>ESPRESSO WILD</button></div>
                        </div>
                    ], {
                        orientation: "horizontal",
                        valign: "bottom",
                        responsive: true
                    })}
                </div>


                <div id="rezepte-1" style="background:#F0EAE7;padding-top:5rem;padding-bottom:3rem;">
                    {new StackPanelComponent([
                        <div style="text-align:center;">
                            <img src={mapUrl("Content/images/sommer/Coffee1.png")} alt="Tropical Espresso" style="max-width:14rem;margin:auto;" />
                        </div>,
                        <div style="line-height:1.5rem;padding:.4rem;">
                            <h1 style="font-size:2rem;color:#FF2D30;margin-bottom:2.5rem;">Für unseren Espresso Torino</h1>
                            <h2 style="font-size:2.8rem;margin-top:0;">Tropical Espresso</h2>

                            <ul style="padding-inline-start: 1.2rem;">
                                <li>Bereite Espresso (40 ml) zu und rühre Zucker (1 Teelöffel) ein</li>
                                <li>Warte bis der Kaffee abgekühlt ist</li>
                                <li>Gib anschliessend je eine Kugel Orange-Maracuja dazu</li>
                                <li>Caramelsirup (1 Teelöffel) darüberträufeln</li>
                                <li>Schneide eine Zitrone oder Orange in Scheiben und verziere den Glasrand damit</li>
                            </ul>

                            <div style="color:#FF2D30">Settings:</div>
                            <div>NIVONA Espresso Torino (Robusta)</div>
                            <div>Profil INTENSE</div>
                            <div>Temperatur hoch</div>
                            <div>Glasvolumen 200ml</div>
                        </div>
                    ], { orientation: "horizontal", valign: "top", sizes: ["50%", "50%"], responsive: true, style: "max-width:1200px;margin:auto;" })}

                </div>


                <div id="rezepte-2" style="padding-top:5rem;padding-bottom:3rem;">
                    {new StackPanelComponent([
                        <div style="line-height:1.5rem;padding:.4rem;">
                            <h1 style="font-size:2rem;color:#FF2D30;margin-bottom:2.5rem;">Für unseren Espresso Milano</h1>
                            <h2 style="font-size:2.8rem;margin-top:0;">Cappuccino Ice</h2>

                            <ul style="padding-inline-start: 1.2rem;">
                                <li>Vanille Eis ins Glas (1 Kugel)</li>
                                <li>Cappuccino zubereiten (200 ml)</li>
                                <li>Topping Schokoladenraspeln</li>
                                <li>Addon Schokoladensauce</li>
                            </ul>

                            <div style="color:#FF2D30">Settings:</div>
                            <div>NIVONA Milano (oder Mischung Arabica und Robusta)</div>
                            <div>Profil CONSTANT</div>
                            <div>Temperatur hoch</div>
                            <div>Glasvolumen 300ml</div>
                        </div>,
                        <div style="text-align:center;">
                            <img src={mapUrl("Content/images/sommer/Coffee2.png")} alt="Cappuccino Ice" style="max-width:14rem;margin:auto;" />
                        </div>
                    ], { orientation: "horizontal", valign: "top", sizes: ["50%", "50%"], responsive: true, style: "max-width:1200px;margin:auto;" })}

                </div>



                <div id="rezepte-3" style="background:#F0EAE7;padding-top:5rem;padding-bottom:3rem;">
                    {new StackPanelComponent([
                        <div style="text-align:center;">
                            <img src={mapUrl("Content/images/sommer/Coffee3.png")} alt="Espresso wild" style="max-width:14rem;margin:auto;" />
                        </div>,
                        <div style="line-height:1.5rem;padding:.4rem;">
                            <h1 style="font-size:2rem;color:#FF2D30;margin-bottom:2.5rem;">Für unseren Espresso Arezzo</h1>
                            <h2 style="font-size:2.8rem;margin-top:0;">Espresso wild</h2>

                            <ul style="padding-inline-start: 1.2rem;">
                                <li>Gefrorene Beeren (50 g) in das Glas</li>
                                <li>Espresso (40 ml) in das Glas einfüllen</li>
                                <li>Wild Berry bis an den Rand des Glases</li>
                                <li>Zwei bis drei Minzblätter zum Garnieren</li>
                            </ul>

                            <div style="color:#FF2D30">Settings:</div>
                            <div>NIVONA Arezzo (oder 100% Arabica)</div>
                            <div>Profil INTENSE</div>
                            <div>Temperatur hoch</div>
                            <div>Glasvolumen 200ml</div>
                        </div>
                    ], { orientation: "horizontal", valign: "top", sizes: ["50%", "50%"], responsive: true, style: "max-width:1200px;margin:auto;" })}

                </div>


                <p>&nbsp;</p>

                <div style="background:#2C2E34;padding:1.2rem;line-height:1.2rem;text-align:center">
                    {new StackPanelComponent([
                        <div><a style="color:white!important;" target="_blank" href="https://nivona.com">www.nivona.com</a></div>,

                        <div><a style="color:white!important;" target="_blank" href="https://nivona.com/impressum/">Impressum</a></div>,

                        <div><a style="color:white!important;" target="_blank" href="https://nivona.com/datenschutz/">Datenschutz</a></div>
                    ], { orientation: "horizontal", responsive: true })}
                </div>

            </div> */}
        </div>;
    }

}